export enum OpenDialogAction {
  "ADD"= "ADD",
  "EDIT"= "EDIT"
}
